export type KeyValueMapping<T> = { [key: string]: T };

export type CustomDateRange = { start: Date, end: Date };

export enum VerificationStatus {
  Success = 'Success',
  Error = 'Error',
}